import React, {Component} from 'react';
import './Explorer.css';

class Explorer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			shown: 0,
			direction: true // forwards
		};
	}

	nextItem = () => {
		if (!this.len()) return;
		// Increment shown feature index
		this.setState({
			shown: (this.state.shown + 1) % this.len(),
			direction: true // forwards
		});
	};

	previousItem = () => {
		if (!this.len()) return;
		// Increment shown feature index
		this.setState({
			shown: (this.state.shown + this.len() - 1) % this.len(),
			direction: false // backwards
		});
	};

	len = () => (this.props.items ? this.props.items.length : 0);

	isIndexShown = (shownIdx, idx) => {
		if (idx === shownIdx) return 'shown';
		if (idx === Math.max((shownIdx + this.len() - 1) % this.len())) return 'hidden';
		return 'prehidden';
	};

	render() {
		const {className, items = []} = this.props;
		return (
			<div
				className={`Explorer ${className || ''} ${
					this.state.direction ? 'direction-forwards' : 'direction-backwards'
				}`}>
				<button onClick={this.previousItem}>&lt;</button>
				<ol>
					{items &&
						items.map((item, idx) => (
							<li key={idx} className={this.isIndexShown(this.state.shown, idx)}>
								{item.leftImg && (
									<div class={`primary ${item.leftImgFancy !== false ? 'fancy' : ''}`}>
										<img src={item.leftImg} alt={item.leftImgAlt} />
									</div>
								)}
								<aside>
									<p>{item.aside}</p>
								</aside>
								{item.rightImg && (
									<div class={`primary ${item.rightImgFancy !== false ? 'fancy' : ''}`}>
										<img src={item.rightImg} alt={item.rightImgAlt} />
									</div>
								)}
							</li>
						))}
				</ol>
				<button onClick={this.nextItem}>&gt;</button>
			</div>
		);
	}
}

export default Explorer;



// WEBPACK FOOTER //
// ./src/widgets/Explorer.js